import { NotFound } from 'shell/error/components/error-not-found';
import HomePage from 'mutation/pages/home';
import RegistrationMarriagePage from 'mutation/pages/registration-marriage/resident';
import PersonsPage from 'mutation/pages/registration-marriage/resident/search-person';
import {
  MarriageMenuAuthorization,
  CancelMarriageAuthorizations,
  UpdateParenthoodAuthorizations,
  RegistrationBewareAuthorizations,
  RegistrationCitizenshipAuthorizations,
  CohabitationMutationAuthorizations,
  RegistrationCivilUnionAuthorization,
  CancelCivilUnionAuthorization,
  RegistrationAnomalyAuthorizations,
} from 'shell/authorizations/mutation';
import PersonsPageCancelMarriage from 'mutation/pages/cancel-marriage/search-person';
import CancelMarriagePage from 'mutation/pages/cancel-marriage/cancel';
import { WidowhoodMenuAuthorization } from 'shell/authorizations/mutation';
import SearchPersonWidowhoodPage from 'mutation/pages/registration-widowhood/search-person';
import RegistrationWidowhoodPage from 'mutation/pages/registration-widowhood/registration';
import RegistrationCitizenshipPersonsPage from 'mutation/pages/registration-citizenship/search-person';
import RegistrationCitizenshipPage from 'mutation/pages/registration-citizenship/registration';
import DeclarationCohabitationPersonsPage from 'mutation/pages/declaration-cohabitation/search-person';
import DeclarationCohabitationPage from 'mutation/pages/declaration-cohabitation';
import UpdateParenthoodPage from 'mutation/pages/update-parenthood';
import PersonsPageCivilUnion from 'mutation/pages/registration-civil-union/resident/search-person';
import RegistrationCivilUnionPage from 'mutation/pages/registration-civil-union/resident/registration';
import SearchPersonsPageCivilUnion from 'mutation/pages/cancel-civil-union/search-person';
import CancelCivilUnionPage from 'mutation/pages/cancel-civil-union/cancel';
import WrapperPersonSearch from 'shell/components/shared/person-search/wrapper-person-search';
import ManagementAnomalyPage from 'mutation/pages/management-anomaly';
import ManagementBewarePage from 'mutation/pages/registration-beware';
import ResolutionFactoCohabitationSearchPage from 'mutation/pages/resolution-facto-cohabitation/search-person';
import ResolutionFactoCohabitationPage from 'mutation/pages/resolution-facto-cohabitation';
import PageResearchNotificationsInitizializer from 'shell/components/shared/research-notifications';
import ResearchFamilyNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/family';
import ResearchFamilyNotificationsDetailPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/family/detail';
import ResearchFamilyNotificationsMotherPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/mother';
import ResearchFamilyNotificationsMotherDetailPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/mother/detail';
import ResearchFamilyNotificationsFatherPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/father';
import ResearchFamilyNotificationsFatherDetailPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/father/detail';
import ResearchFamilyNotificationsOtherPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/other';
import ResearchFamilyNotificationsOtherDetailPage from 'mutation/pages/research-registration-civil-status-registry-office/research-family/other/detail';
import ResearchCohabitationNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-cohabitation';
import { Outlet } from 'react-router-dom';
import ResearchCohabitationNotificationsDetailPage from 'mutation/pages/research-registration-civil-status-registry-office/research-cohabitation/detail';
import ResearchDeathNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-death';
import CancellationDeathNotificationPage from 'mutation/pages/research-registration-civil-status-registry-office/research-death/detail';
import ResearchMarriageNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-marriage';
import ResearchMarriageDetailNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-marriage/detail';
import PersonsPageNonResident from 'mutation/pages/registration-marriage/non-resident/search-person';
import RegistrationMarriageNonResidentPage from 'mutation/pages/registration-marriage/non-resident';
import PersonSipoNonResidentSearchPage from 'mutation/pages/registration-marriage/non-resident/edit-person-search';
import PersonSipoNonResidentPage from 'mutation/pages/registration-marriage/non-resident/edit-person';
import RegistrationCivilUnionNonResidentPage from 'mutation/pages/registration-civil-union/non-resident';
import PersonsPageCivilUnionNonResident from 'mutation/pages/registration-civil-union/non-resident/search-person';
import EditPersonsPageCivilUnionNonResidentSearchPage from 'mutation/pages/registration-civil-union/non-resident/edit-person-search';
import EditPersonsPageCivilUnionNonResidentPage from 'mutation/pages/registration-civil-union/non-resident/edit-person';
import ResearchMarriageNonResidentNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-marriage-non-resident';
import ResearchMarriageNonResidentDetailNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person';
import PersonSearchMarriageNonResidentNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-marriage-non-resident/edit-person-search';
import ResearchDeathNonResidentNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-death-non-resident';
import ResearchDeathNonResidentDetailNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-death-non-resident/detail';
import PersonSearchDeathNonResidentNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-death-non-resident/edit-person-search';
import ResearchNotificationsCivilStatusRegistryOfficePage from 'mutation/pages/research-registration-civil-status-registry-office/list';
import AnscNotificationsPage from 'mutation/pages/ansc-notification/list';
import DetailNotificationsCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/detail';
import EditNotificationsCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/edit';
import AnscNotificationsEditPage from 'mutation/pages/ansc-notification/edit';
import AnscNotificationsDetailPage from 'mutation/pages/ansc-notification/detail';
import ResearchBirthNonResidentNotificationsCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/reasearch-birth-non-resident';
import ResearchCivilUnionNotificationCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/research-civil-union';
import RegistrationCivilUnionDetailNotificationsPage from 'mutation/pages/research-registration-civil-status-registry-office/research-civil-union/detail';
import ResearchCivilUnionNonResidentNotificationCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentNotificationCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionDetailNotificationsCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentNotificationCivilStatusPage from 'mutation/pages/research-registration-civil-status-registry-office/research-civil-union-non-resident/edit-person';
import AnscNotificationsBirthNonResidentPage from 'mutation/pages/ansc-notification/birth-non-resident';
import ResearchFamilyNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-family/family';
import ResearchFamilyNotificationsFatherDetailCivilStatusPage from 'mutation/pages/ansc-notification/research-family/father/detail';
import ResearchFamilyNotificationsMotherCivilStatusPage from 'mutation/pages/ansc-notification/research-family/mother';
import ResearchFamilyNotificationsDetailCivilStatusPage from 'mutation/pages/ansc-notification/research-family/family/detail';
import ResearchFamilyNotificationsMotherDetailCivilStatusPage from 'mutation/pages/ansc-notification/research-family/mother/detail';
import ResearchFamilyNotificationsFatherCivilStatusPage from 'mutation/pages/ansc-notification/research-family/father';
import ResearchFamilyNotificationsOtherCivilStatusPage from 'mutation/pages/ansc-notification/research-family/other';
import ResearchFamilyNotificationsOtherDetailCivilStatusPage from 'mutation/pages/ansc-notification/research-family/other/detail';
import ResearchCohabitationNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-cohabitation';
import RegisterCohabitationNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-cohabitation/detail';
import ResearchDeathNotificationResidentCivilStatusPage from 'mutation/pages/ansc-notification/research-death';
import CancellationDeathNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-death/detail';
import ResearchDeathNonResidentNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-death-non-resident';
import PersonSearchDeathNonResidentNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-death-non-resident/edit-person-search';
import CancellationNonResidentNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-death-non-resident/detail';
import ResearchMarriageNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-marriage';
import ResearchMarriageDetailNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-marriage/detail';
import ResearchMarriageNonResidentNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-marriage-non-resident';
import PersonSearchMarriageNonResidentNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-marriage-non-resident/edit-person-search';
import ResearchMarriageNonResidentDetailNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-marriage-non-resident/detail';
import PersonMarriageNonResidentNotificationsCivilStatusPage from 'mutation/pages/ansc-notification/research-marriage-non-resident/edit-person';
import ResearchCivilUnionAnscNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-civil-union';
import RegistrationCivilUnionDetailAnscNotificationPage from 'mutation/pages/ansc-notification/research-civil-union/detail';
import ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-civil-union-non-resident';
import PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-civil-union-non-resident/edit-person-search';
import RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-civil-union-non-resident/detail';
import PersonCivilUnionNonResidentAnscNotificationCivilStatusPage from 'mutation/pages/ansc-notification/research-civil-union-non-resident/edit-person';
import ResearchCitizenshipAnscNotificationsPage from 'mutation/pages/ansc-notification/research-citizenship';
import RegistrationCitizenshipAnscNotificationsPage from 'mutation/pages/ansc-notification/research-citizenship/detail';

export const mutationRoutes = [
  {
    path: '',
    element: <WrapperPersonSearch />,
    children: [
      {
        path: '',
        name: 'Mutazioni',
        element: <HomePage />,
      },
      {
        path: '/persona/matrimonio',
        authorizations: MarriageMenuAuthorization,
        name: 'Registrazione Matrimonio',
        children: [
          {
            path: '/residenti',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PersonsPage />,
              },
              {
                path: '/registrazione',
                element: <RegistrationMarriagePage />,
              },
            ],
          },
          {
            path: '/non-residenti',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PersonsPageNonResident />,
              },
              {
                path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                element: <Outlet />,
                children: [
                  {
                    element: <RegistrationMarriageNonResidentPage />,
                    path: '',
                  },
                  {
                    path: '/persona-sipo',
                    element: <PersonSipoNonResidentPage />,
                  },
                ],
              },
              {
                path: '/persona-sipo',
                element: <PersonSipoNonResidentSearchPage />,
              },
            ],
          },
        ],
      },
      {
        path: '/notifiche-da-stato-civile',
        element: <PageResearchNotificationsInitizializer />,
        children: [
          {
            path: '',
            element: <ResearchNotificationsCivilStatusRegistryOfficePage />,
          },
          {
            path: '/visualizza/:id/:idNotifica',
            element: <DetailNotificationsCivilStatusPage />,
          },
          {
            path: '/modifica/:id/:idNotifica',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <EditNotificationsCivilStatusPage />,
              },
              {
                path: '/nascita',
                element: <Outlet />,
                children: [
                  {
                    path: '/non-residenti',
                    element: <ResearchBirthNonResidentNotificationsCivilStatusPage />,
                  },
                ],
              },
              {
                path: '/famiglia',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/madre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsMotherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsMotherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/padre',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsFatherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsFatherDetailPage />,
                  },
                ],
              },
              {
                path: '/famiglia/altra',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchFamilyNotificationsOtherPage />,
                  },
                  {
                    path: '/dettaglio',
                    element: <ResearchFamilyNotificationsOtherDetailPage />,
                  },
                ],
              },
              {
                path: '/convivenza',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <ResearchCohabitationNotificationsPage />,
                  },
                  {
                    path: '/nascita',
                    element: <ResearchCohabitationNotificationsDetailPage />,
                  },
                ],
              },
              {
                path: '/morte',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNotificationsPage />,
                      },
                      {
                        path: '/cancellazione',
                        element: <CancellationDeathNotificationPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchDeathNonResidentNotificationsPage />,
                      },
                      {
                        path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentDetailNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/matrimonio',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <ResearchMarriageDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchMarriageNonResidentNotificationsPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentDetailNotificationsPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonMarriageNonResidentNotificationsPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
              {
                path: '/unione-civile',
                element: <Outlet />,
                children: [
                  {
                    path: '/residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCivilUnionDetailNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/non-residenti',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/persona-sipo',
                        element: <PersonSearchCivilUnionNonResidentNotificationCivilStatusPage />,
                      },
                      {
                        path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <RegistrationCivilUnionDetailNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonCivilUnionNonResidentNotificationCivilStatusPage />,
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '/notifiche',
        element: <Outlet />,
        children: [
          {
            path: '/ansc',
            element: <PageResearchNotificationsInitizializer />,
            children: [
              {
                path: '',
                element: <AnscNotificationsPage />,
              },
              {
                path: '/visualizza/:id/:idNotifica',
                element: <AnscNotificationsDetailPage />,
              },
              {
                path: '/modifica/:id/:idNotifica',
                element: <Outlet />,
                children: [
                  {
                    path: '',
                    element: <AnscNotificationsEditPage />,
                  },
                  {
                    path: '/cittadinanza/ricerca',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCitizenshipAnscNotificationsPage />,
                      },
                      {
                        path: '/registrazione',
                        element: <RegistrationCitizenshipAnscNotificationsPage />,
                      },
                    ],
                  },
                  {
                    path: '/nascita',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/non-residenti',
                        element: <AnscNotificationsBirthNonResidentPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/madre',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsMotherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsMotherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/padre',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsFatherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsFatherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/famiglia/altra',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchFamilyNotificationsOtherCivilStatusPage />,
                      },
                      {
                        path: '/dettaglio',
                        element: <ResearchFamilyNotificationsOtherDetailCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/convivenza',
                    element: <Outlet />,
                    children: [
                      {
                        path: '',
                        element: <ResearchCohabitationNotificationCivilStatusPage />,
                      },
                      {
                        path: '/nascita',
                        element: <RegisterCohabitationNotificationCivilStatusPage />,
                      },
                    ],
                  },
                  {
                    path: '/morte',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNotificationResidentCivilStatusPage />,
                          },
                          {
                            path: '/cancellazione',
                            element: <CancellationDeathNotificationCivilStatusPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchDeathNonResidentNotificationCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: <PersonSearchDeathNonResidentNotificationCivilStatusPage />,
                          },
                          {
                            path: '/cancellazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: <CancellationNonResidentNotificationCivilStatusPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/matrimonio',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/registrazione',
                            element: <ResearchMarriageDetailNotificationsCivilStatusPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchMarriageNonResidentNotificationsCivilStatusPage />,
                          },
                          {
                            path: '/persona-sipo',
                            element: (
                              <PersonSearchMarriageNonResidentNotificationsCivilStatusPage />
                            ),
                          },
                          {
                            path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: (
                                  <ResearchMarriageNonResidentDetailNotificationsCivilStatusPage />
                                ),
                              },
                              {
                                path: '/persona-sipo',
                                element: <PersonMarriageNonResidentNotificationsCivilStatusPage />,
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                  {
                    path: '/unione-civile',
                    element: <Outlet />,
                    children: [
                      {
                        path: '/residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: <ResearchCivilUnionAnscNotificationCivilStatusPage />,
                          },
                          {
                            path: '/registrazione',
                            element: <RegistrationCivilUnionDetailAnscNotificationPage />,
                          },
                        ],
                      },
                      {
                        path: '/non-residenti',
                        element: <Outlet />,
                        children: [
                          {
                            path: '',
                            element: (
                              <ResearchCivilUnionNonResidentAnscNotificationNotificationCivilStatusPage />
                            ),
                          },
                          {
                            path: '/persona-sipo',
                            element: (
                              <PersonSearchCivilUnionNonResidentAnscNotificationCivilStatusPage />
                            ),
                          },
                          {
                            path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                            element: <Outlet />,
                            children: [
                              {
                                path: '',
                                element: (
                                  <RegistrationCivilUnionNonResidentDetailAnscNotificationCivilStatusPage />
                                ),
                              },
                              {
                                path: '/persona-sipo',
                                element: (
                                  <PersonCivilUnionNonResidentAnscNotificationCivilStatusPage />
                                ),
                              },
                            ],
                          },
                        ],
                      },
                    ],
                  },
                ],
              },
            ],
          },
        ],
      },
      {
        path: '/persona/matrimonio-annullamento',
        name: 'Annullamento di Matrimonio',
        authorizations: CancelMarriageAuthorizations,
        children: [
          {
            path: '',
            element: <PersonsPageCancelMarriage />,
          },
          {
            path: '/annullamento',
            element: <CancelMarriagePage />,
          },
        ],
      },
      {
        path: '/persona/unione-civile',
        name: 'Registrazione Unione Civile',
        authorizations: RegistrationCivilUnionAuthorization,
        children: [
          {
            path: '/residenti',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PersonsPageCivilUnion />,
              },
              {
                path: '/registrazione',
                element: <RegistrationCivilUnionPage />,
              },
            ],
          },
          {
            path: '/non-residenti',
            element: <Outlet />,
            children: [
              {
                path: '',
                element: <PersonsPageCivilUnionNonResident />,
              },
              {
                path: '/registrazione/:idIntestatario/:idSchedaSoggettoANPR',
                element: <Outlet />,
                children: [
                  {
                    element: <RegistrationCivilUnionNonResidentPage />,
                    path: '',
                  },
                  {
                    path: '/persona-sipo',
                    element: <EditPersonsPageCivilUnionNonResidentPage />,
                  },
                ],
              },
              {
                path: '/persona-sipo',
                element: <EditPersonsPageCivilUnionNonResidentSearchPage />,
              },
            ],
          },
        ],
      },
      {
        path: '/cerca-persona/unione-civile',
        name: 'Annullamento Unione Civile',
        authorizations: CancelCivilUnionAuthorization,
        children: [
          {
            path: '',
            element: <SearchPersonsPageCivilUnion />,
          },
          {
            path: '/scioglimento',
            element: <CancelCivilUnionPage />,
          },
        ],
      },
      {
        path: '/persona/vedovanza',
        authorizations: WidowhoodMenuAuthorization,
        name: 'Registrazione Vedovanza',
        children: [
          {
            path: '',
            element: <SearchPersonWidowhoodPage />,
          },
          {
            path: '/registrazione',
            element: <RegistrationWidowhoodPage />,
          },
        ],
      },
      {
        path: '/persona/convivenza',
        name: 'Registrazione Convivenza di Fatto',
        authorizations: CohabitationMutationAuthorizations,
        children: [
          {
            path: '',
            element: <DeclarationCohabitationPersonsPage />,
          },
          {
            path: '/dichiarazione',
            element: <DeclarationCohabitationPage />,
          },
        ],
      },
      {
        path: '/persona/risoluzione-convivenza-di-fatto',
        name: 'Risoluzione Convivenza di Fatto',
        authorizations: CohabitationMutationAuthorizations,
        children: [
          {
            path: '',
            element: <ResolutionFactoCohabitationSearchPage />,
          },
          {
            path: '/risoluzione',
            element: <ResolutionFactoCohabitationPage />,
          },
        ],
      },
      {
        path: '/persona/cittadinanza',
        name: 'Registrazione Cittadinanza',
        authorizations: RegistrationCitizenshipAuthorizations,
        children: [
          {
            path: '',
            element: <RegistrationCitizenshipPersonsPage />,
          },
          {
            path: '/registrazione',
            element: <RegistrationCitizenshipPage />,
          },
        ],
      },
      {
        path: '/diffida/registrazione',
        name: 'Gestione Diffida',
        authorizations: RegistrationBewareAuthorizations,
        children: [
          {
            path: '',
            element: <ManagementBewarePage />,
          },
        ],
      },
      {
        path: '/anomalia/registrazione',
        name: 'Gestione Anomalie',
        authorizations: RegistrationAnomalyAuthorizations,
        children: [
          {
            path: '',
            element: <ManagementAnomalyPage />,
          },
        ],
      },
      {
        path: '/parentela/aggiornamento',
        name: 'Aggiornamento Parentela',
        authorizations: UpdateParenthoodAuthorizations,
        children: [
          {
            path: '',
            element: <UpdateParenthoodPage />,
          },
        ],
      },
      {
        element: <NotFound />,
        path: '*',
        hidden: true,
      },
    ],
  },
];
